import { default as authorFromScratchTemplate } from "./author-from-scratch";

const authorFromScratch = [authorFromScratchTemplate];

export default authorFromScratch;
